import React, { useState } from "react";
import Box from "react-raster";
import { Heading, Spacer, Toggle } from "src/components";
import { theme } from "src/config";
import { Colors } from "src/types";

export const ToggleSection = () => {
  const [primarychecked, setPrimaryChecked] = useState(false);
  const [disabledChecked, setDisabledChecked] = useState(false);

  return (
    <Box gridRowGap={theme.layout.gutterSmall}>
      <Heading weight="normal" type="h3" color="black">
        Toggle
      </Heading>
        <hr />
      <Toggle
        label="Primary"
        checked={primarychecked}
        onCheckedChange={() => setPrimaryChecked(!primarychecked)}
      />
      <Spacer/>
      <Toggle
        label="Disabled"
        disabled={true}
        checked={disabledChecked}
        onCheckedChange={() => setDisabledChecked(!disabledChecked)}
      />
    </Box>
  );
};
